<template>
  <div>
    <h3>
      <icon class="mr-1" type="chart-pie"/>
      {{ $t('VMUsage') }}
    </h3>
    <hr class="panel-hr"/>
    <log-summary :auto-load="true" :logs="logs" :organization-id="$route.params.id"/>
    <log-viewer v-if="logs && false" :data="logs"/>
  </div>
</template>

<script>
import LogViewer from "@/components/dashboard/LogViewer.vue";
import LogSummary from "@/components/dashboard/LogSummary.vue";
import Icon from "@/components/Icon.vue";

export default {
  name: "VmUsagePanel",
  components: {Icon, LogSummary, LogViewer},
  props: {
    organizationId: {type: String, required: true},
    autoLoad: {type: Boolean, default: false},
  },
  data() {
    return {
      logs: null,
    };
  },
  beforeMount() {
    if (this.autoLoad) {
      this.loadVMLogs();
    }
  },
  methods: {
    async loadVMLogs() {
      this.$store.dispatch('clientLoadVMLogs', {
        sort: '-createdAt',
        filter: 'organizationId eq ' + this.organizationId,
      }).then(data => {
        this.logs = data;
      })
    },
  }
}
</script>
